 import Api from '@/api/api'
import apiCommonUrl from '@/api/apiCommonUrl';

export default{
    getDeviceMonitorData(){
         return apiCommonUrl.get('monitoring/FaultData/GetAllFaultData')
        //  return apiCommonUrl.get(`monitoring/FaultData/GetAllFaultData`);
    },
    getInitialData() {
        return Api.get('/api/InitialData/GetSuperAdminInitialData');
    },
    getProcessedData(deviceId){
        return apiCommonUrl.get(`monitoring/FaultData/GetLastProcessedData?deviceId=${deviceId}`)
    },
    getUnRegisteredData(){
        return apiCommonUrl.get('monitoring/api/UnRegisteredDevices//GetAllUnregisteredData')
    },
    acknowledgeDeviceMonitorData(deviceId){
        return apiCommonUrl.post(`monitoring/FaultData/AcknowledgeFaultData?deviceId=${deviceId}`)
    },
    acknowledgeUnRegisterData(deviceId){
        return apiCommonUrl.post(`/monitoring/api/UnRegisteredDevices/AcknowledgeUnRegisteredData?deviceId=${deviceId}`)
    }
}